import { Component, Input } from '@angular/core'

@Component({
  selector: 'atyl-loading',
  templateUrl: './loading.component.html',
  styleUrls: ['./loading.component.scss']
})
export class LoadingComponent {

  @Input() text: string = 'Chargement...'
  constructor() { }

}
